import * as Yup from 'yup';
import { MethodOD } from '@models';

export function useValidationSchema() {
  return Yup.object<MethodOD>().shape({
    code: Yup.string().nullable().required('Povinné pole'),
    name: Yup.string().nullable().required('Povinné pole'),
    active: Yup.boolean().nullable(),
  }) as Yup.Schema<MethodOD>;
}
